import BlButtonAv from './BlButtonAv.vue'

BlButtonAv.install = function(Vue) {
  Vue.component(BlButtonAv.name, BlButtonAv)
}

export default BlButtonAv
